import React, { useEffect, useState } from 'react'
import { useGlobal, useGlobalDispatch } from '../../core/GlobalContext'
import { PROFILE_DUCK } from '../../core/actions'
import { removeSpaces } from '../../utils/misc'
import InputInlineWithLabel from '../inputInlineWithLabel'

export const ChangeBankAccountAttribute = ({ attr, disabled = false }) => {
  const [inputVal, setInputVal] = useState('')

  const {
    financierState: { updateBank, updateBankMessages },
  } = useGlobal()
  const { financierDispatch } = useGlobalDispatch()

  // Obtains value from global state and populates input with it.
  useEffect(() => {
    if (!inputVal && updateBank[attr.type]) {
      setInputVal(updateBank[attr.type])
    } else if (!updateBank[attr.type]) {
      setInputVal('')
    }
    // Special condition that changes bank name irrespective of what user types and relies solely on getBankNameFromIFSC
    else if (inputVal !== updateBank[attr.type] && attr.type === 'bankName') {
      setInputVal(updateBank[attr.type])
    }
  }, [inputVal, updateBank, attr.type])

  const autoCorrectValues = val => {
    if (attr?.type === 'accountNumber' || attr?.type === 'reAccountNumber') {
      return val ? removeSpaces(val) : val
    }

    if (attr?.type === 'bankName' || attr?.type === 'holderName') {
      return val ? val.trim() : val
    }

    if (attr?.type === 'ifsc') {
      return val ? removeSpaces(val.toUpperCase()) : val?.toUpperCase()
    }
    return val
  }

  const handleInputChange = val => {
    const correctedVal = autoCorrectValues(val)
    setInputVal(correctedVal)
    financierDispatch({
      type: PROFILE_DUCK.UPDATE_BANK_VALUES,
      payload: { updateBank: { [attr?.type]: correctedVal } },
    })
  }
  return (
    <InputInlineWithLabel
      title={attr?.title}
      placeholder={attr?.placeholder ? attr.placeholder : attr?.title}
      value={inputVal}
      setValue={handleInputChange}
      editable={!disabled}
      // TODO Messages should support custom msg types
      message={updateBankMessages[attr?.type]?.value}
    />
  )
}
